/**
 * Metadados de UI por etapa da fila de fretes do GoBID (PO1-2784, fase 1).
 * As 4 etapas e seus status de origem espelham backend_hub
 * src/app/modules/gobid-fila-fretes/etapas.js — mesma correspondência de cor
 * usada pelos badges de status da Minhas Cotações (STATUS_COLORS).
 */
export const ETAPAS_UI = {
  orc_aguardando_pedido: {
    label: "ORC aguardando pedido",
    tone: "neutral",
    icon: "tim-icons icon-notes",
  },
  br_aguardando_aprovacao: {
    label: "BR aguardando aprovação",
    tone: "warning",
    icon: "tim-icons icon-time-alarm",
  },
  aprovado_aguardando_transportadora: {
    label: "Aprovado, aguardando transportadora",
    tone: "info",
    icon: "tim-icons icon-send",
  },
  expedido: {
    label: "Expedido",
    tone: "success",
    icon: "tim-icons icon-delivery-fast",
  },
};

export const ETAPAS_ORDEM = [
  "orc_aguardando_pedido",
  "br_aguardando_aprovacao",
  "aprovado_aguardando_transportadora",
  "expedido",
];

export function etapaLabel(key) {
  return (ETAPAS_UI[key] && ETAPAS_UI[key].label) || key || "-";
}
